/**
 * Team Flip Card - Mobile Click Handler
 * Simple, consistent click handler for mobile devices
 */

const isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)');

const initTeamFlipCards = () => {
  const flipCards = document.querySelectorAll('.team-flip-card');

  if (!flipCards.length || !isTouchDevice.matches) return;

  flipCards.forEach(card => {
    // Simple, direct click handler
    card.addEventListener('click', () => {
      card.classList.toggle('flipped');
      card.classList.add('has-interacted');
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTeamFlipCards, {
    once: true,
  });
} else {
  initTeamFlipCards();
}
